import { gql } from 'src/utils/gql/query';

export const speakersGqlFragment = gql`
  fragment speakers on people {
    id
    avatar {
      id
    }
    name
    translations {
      degree
      title
      languages_code {
        code
      }
    }
    country {
      translations {
        languages_code {
          code
        }
        name
      }
    }
  }
`;
